<template>
  <ValidationProvider name="Audience Type" slim vid="facebook_audience_type" rules="required">
    <template #default="{ errors }">
      <BaseFormGroup>
        <BaseFormLabel for="facebook_audience_type"> Audience Type </BaseFormLabel>
        <VSelect
          id="facebook_audience_type"
          v-model="audienceType"
          :options="audienceTypeOptions"
          label="label"
          :reduce="(audienceType) => audienceType.value"
          :disabled="disabled"
          class="vue-select custom-option"
        >
          <template #option="{ label }">
            <div class="flex group px-4 py-2 items-center">
              <p class="text-sm font-medium text-gray-900 group-hover:text-white">
                {{ label }}
              </p>
            </div>
          </template>
        </VSelect>
        <BaseFormInlineMessage v-if="errors.length" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </BaseFormGroup>
    </template>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    disabled: Boolean,
  },
  data() {
    return {
      audienceTypeOptions: [
        { label: 'Custom Audience', value: 'custom' },
        { label: 'Saved Audience', value: 'saved' },
      ],
    };
  },
  computed: {
    audienceType: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
